import client from '@lib/core/axios.client';
import { API_ENDPOINTS } from '@lib/constants';
import type {
    EmailTemplateAdminDto,
    EmailTemplateListItem,
    PreviewEmailTemplateRequest,
    RenderedEmailTemplateDto,
    SendTestEmailTemplateRequest,
    SendTestEmailTemplateResponse,
    UpdateEmailTemplateRequest,
} from '@/types/api/admin';

export class AdminEmailTemplateService {
    private static instance: AdminEmailTemplateService;

    private constructor() { }

    public static getInstance(): AdminEmailTemplateService {
        if (!AdminEmailTemplateService.instance) {
            AdminEmailTemplateService.instance = new AdminEmailTemplateService();
        }

        return AdminEmailTemplateService.instance;
    }

    async listTemplates(): Promise<EmailTemplateListItem[]> {
        return await client.get<EmailTemplateListItem[]>(
            API_ENDPOINTS.ADMIN.EMAIL_TEMPLATES.LIST,
        );
    }

    async getTemplate(templateKey: string): Promise<EmailTemplateAdminDto> {
        return await client.get<EmailTemplateAdminDto>(
            API_ENDPOINTS.ADMIN.EMAIL_TEMPLATES.BY_KEY(templateKey),
        );
    }

    async updateTemplate(templateKey: string, data: UpdateEmailTemplateRequest): Promise<EmailTemplateAdminDto> {
        return await client.put<EmailTemplateAdminDto>(
            API_ENDPOINTS.ADMIN.EMAIL_TEMPLATES.BY_KEY(templateKey),
            data,
        );
    }

    async previewTemplate(templateKey: string, data: PreviewEmailTemplateRequest): Promise<RenderedEmailTemplateDto> {
        return await client.post<RenderedEmailTemplateDto>(
            API_ENDPOINTS.ADMIN.EMAIL_TEMPLATES.PREVIEW_BY_KEY(templateKey),
            data,
        );
    }

    async sendTestEmail(templateKey: string, data: SendTestEmailTemplateRequest): Promise<SendTestEmailTemplateResponse> {
        return await client.post<SendTestEmailTemplateResponse>(
            API_ENDPOINTS.ADMIN.EMAIL_TEMPLATES.SEND_TEST_BY_KEY(templateKey),
            data,
        );
    }
}

export const adminEmailTemplateService = AdminEmailTemplateService.getInstance();
export default adminEmailTemplateService;
